import { RowNode } from '@ag-grid-community/core'
import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import {
  HeliosServerSideRequest,
  genericHeliosRequest,
} from '@helios/server-side-util'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import {
  ExternalDataSourceTypeId,
  ExternalDataSourceTypeName,
} from '../../../../model/single-transaction/external-unmatched-transaction'
import { PosIdResponse } from '../../../../model/single-transaction/security-transfer/position.model'
import { HttpPositionsService } from '../../../../services/single-transaction/http-positions.service'
import { setHighestZIndexForOpenModals } from '../../../../util/common-utils'
import { TransactionConstants } from '../../../../util/constants'

@Component({
  selector: 'hs-request-price',
  templateUrl: './request-price.component.html',
  styleUrls: ['./request-price.component.scss'],
})
export class RequestPriceComponent implements OnInit {
  @Input() assetId?: string
  @Input() priceNode?: RowNode

  readonly title = 'Requested External Price'
  readonly compId = TransactionConstants.TRANSFER_PRICE_REQUEST_COMP_ID

  radioSource: FormControl = new FormControl('1')
  selectedOption: ExternalDataSourceTypeName = 'Custody'
  price = 0.0
  message = ''
  loadingPrice = false

  constructor(
    readonly activeModal: NgbActiveModal,
    readonly eleRef: ElementRef,
    private readonly positionsService: HttpPositionsService,
  ) {}

  ngOnInit() {
    setHighestZIndexForOpenModals(this.compId, this.eleRef)
    this.requestedPrice(ExternalDataSourceTypeId.Custody)
    this.radioSource.valueChanges
      .pipe()
      .subscribe((newVal: ExternalDataSourceTypeId) => {
        this.onExternalDataSourceChanged(newVal)
      })
  }

  onExternalDataSourceChanged(source: ExternalDataSourceTypeId) {
    this.selectedOption =
      source == ExternalDataSourceTypeId.Custody ? 'Custody' : 'Trading'
    this.requestedPrice(source)
  }

  async requestedPrice(source: ExternalDataSourceTypeId) {
    if (!this.assetId) {
      this.message = 'No external price found for the given source'
      return
    }

    this.loadingPrice = true
    const request = {
      ...genericHeliosRequest,
      endRow: 1,
      fields: ['extPosId', 'positionId'],
      filter: {
        extPosSourceType: {
          filterType: 'set',
          values: [
            source == ExternalDataSourceTypeId.Custody ? 'CUSTODY' : 'TRADING',
          ],
        },
        secIdentifier: {
          operator: 'OR',
          filterType: 'text',
          filters: [{ operator: 'contains', value: this.assetId }],
        },
      },
    } as HeliosServerSideRequest<PosIdResponse>
    const posIds = await this.positionsService.getPositions(request).toPromise()
    if (posIds.length == 0 || !posIds[0].extPosId) {
      this.message = 'No external price found for the given source'
      this.loadingPrice = false
      return
    }

    const comparisonData = await this.positionsService
      .getPositionComparisons({
        positionId: posIds[0].positionId,
        clearedOnly: false,
        includeValuationData: false,
      })
      .toPromise()
    if (!comparisonData.marketPrice?.extValue) {
      this.message = 'No external price found for the given source'
      this.loadingPrice = false
      return
    }
    this.price = comparisonData.marketPrice.extValue
    this.message =
      'Requested Price from ' + this.selectedOption + ' is ' + this.price
    this.loadingPrice = false
  }

  usePrice() {
    this.priceNode?.setDataValue('value', this.price)
    this.activeModal.close()
  }

  getComponentId() {
    return this.compId
  }
}
